import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_6 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.shadow;
  const colour1 = lipColours.base;
  const colour2 = '#40332E';
  const colour3 = '#F2D5B2';
  const colour4 = '#FFFEF0';
  const colour5 = skinColours.shadow;
  const colour6 = skinColours.shadow;
  const colour7 = '#FFE9CF';

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M323.6,561.4c6.7,1.3,44.1-16.9,54.3-14.8c14.9,3,39.8,27.1,48.9,35.6c0,0-28.8-41-47.9-42.5
		C359.8,538.1,323.6,561.4,323.6,561.4z"
        />
        <path
          fill={colour1}
          d="M322.4,561.4c-2.8-0.7-17.7-10.5-21.2-15.2c0,0,9.5-17.2,21.9-15.3c17.8,2.7,38.3,4.1,53.1,2.9
		c14.8-1.2,88.7-4.8,104.4-1.8c0,0,19.3,30.9,9.9,49c-3.1,6-12,22-14.5,26.4c-3.6,6.4-26.7-3-35.9-11.2c-9.3-8.3-45.8-51.5-60.9-53
		C363.4,541.7,329.4,563,322.4,561.4z"
        />
        <path
          fill={colour0}
          d="M320.9,558.2c-2.7-0.6-13.1-8.4-16.5-12.6c0,0,7-14,18.9-12.1c22.6,3.6,45.1,3.8,53.5,3.4
		c14.1-0.8,87.9-5.7,102.9-2.7c0,0,17.6,30.9,9,46.6c-2.9,5.2-13.8,18.4-16.1,22.2c-3.3,5.6-24.3-5-33.3-12.5
		c-9-7.5-35.6-49.3-61.5-49.6C355.1,540.8,327.6,559.8,320.9,558.2z"
        />
        <path
          fill={colour2}
          d="M321.7,557.2c-2.8-0.7-11-7.9-14.4-12.4c0,0,5.2-10.8,17.3-8.9c17.3,2.6,38,4.5,52.4,3.3
		c14.4-1.2,85.7-4.2,100.9-1.3c0,0,17.1,25.6,8,43.1c-3,5.9-12.3,13.7-14.7,18c-3.6,6.2-20.1-1.2-29.1-9.2c-9-8.1-43.4-46.1-58-48
		C358.7,538.5,324.3,557.8,321.7,557.2z"
        />
        <path
          fill={colour3}
          d="M321.8,553.1c-1.6,0.6-9.1-4.1-8.9-8.4c0.1-1.8,3.3-3.3,5.9-4.6c0,0,15.2,0.4,33.1,1.9
		C351.9,542,331.8,549.5,321.8,553.1z"
        />
        <path
          fill={colour4}
          d="M390.6,541c18.6,6,59.8,50.7,66.5,54.1c3,1.5,8.4,2.8,9.5,1.6c1.1-1.2,16.6-16.5,17.9-23
		c1.7-8.7-5.1-29.1-9.4-31.6C466.3,537.3,390.6,541,390.6,541z"
        />
        <path
          fill={colour3}
          d="M477.9,583.4c-0.8-1.1-8.8-15.7-48.1-29.1c0,0,45,15.3,53.5,8.1C483.2,562.4,486.3,576.5,477.9,583.4z"
        />
        <path
          fill={colour3}
          d="M484.5,573.8c1-5.2-1-14.6-3.7-21.9c2.1,6.6,3.4,14.1,2.6,18.5c-1.3,6.5-15.9,22.7-17,23.9
		c-1.1,1.2-7.4,0.2-10.3-1.4c-6-3.1-39.6-40-59.9-52.1c-3.4,0.1-5.4,0.2-5.4,0.2c18.6,6,59.9,51.8,66.5,55.3c3,1.5,9.3,2.5,10.3,1.4
		C468.6,596.5,483.2,580.3,484.5,573.8z"
        />
        <path
          fill={colour3}
          d="M405.7,546.2c0,0,70.6-1.2,76.7,10.6c-2.1-7-4.5-14-6.8-15.3c-8.8-4.9-85-0.5-85-0.5
		c18.6,6,59.9,51.8,66.5,55.3c0.1,0,0.1,0.1,0.2,0.1C443.4,579.9,410.6,551.5,405.7,546.2z"
        />
        <path
          fill={colour2}
          d="M480.6,583.7c1.7-6.1-13.5-15.9-34.4-23.7c0,0,29.2,10.4,39,4.1C485.2,564,489.6,574.7,480.6,583.7z"
        />
        <path
          fill={colour5}
          d="M293.1,558.2c-2.7-3.6-7.5-8.4-1.5-23.3c0,0-8.9,12.6-6.5,18.7C286.9,558,293.1,558.2,293.1,558.2z"
        />
        <path
          fill={colour1}
          d="M375.1,539.7c-6.8,0-19.7,5-23.8,6.5c-0.2,0.1-0.3,0.1-0.5,0.2c0,0,16.1-4.5,24.5-4.5c8.4,0,21.6,6.2,21.6,6.2
		C391.2,543.3,382.2,539.7,375.1,539.7z"
        />
        <path
          fill={colour2}
          d="M457.1,574.8c4.5-6.6,5.5-6.7,7.5-8.8l-3.3,0.1C461.4,566.1,456.4,575.8,457.1,574.8z"
        />
        <path
          fill={colour2}
          d="M466.7,566.3c0.7-0.4,3.3-3.3,3.9-7.2c0,0,0.6,5.1,0.9,7.9L466.7,566.3z"
        />
        <path
          fill={colour6}
          d="M493.8,535.3c0,0,13.7,14.3,11.3,31.5c0,0,9.5-3.2,10-5.2c0.5-2.1-10.8-21.9-18.2-26.8L493.8,535.3z"
        />
        <path
          fill={colour2}
          d="M393.7,539.5c0,0,20.2,9.4,33.9,14.3c0,0-29.4-10.1-34.9-11l-3.5-1.9L393.7,539.5z"
        />
        <path
          fill={colour2}
          d="M325.1,551.9c-4.8-0.7-8.8-5-3.6-6.6c0,0-7-1.9-2-5.8c0,0-8.2,0.9-8,5.7C311.8,551.9,323.3,556.4,325.1,551.9z
		"
        />
        <path
          fill={colour2}
          d="M353.2,541.1c-0.4,0-12.5,2.7-20.3,3.1c0,0,17.4-1,18.3-0.2L353.2,541.1z"
        />
        <path
          fill={colour2}
          d="M421,551.3c6.1,2.1,7.9,5.8,7.8,7.8c0,0,1.5-3.7,4.1-3.8L421,551.3z"
        />
        <path
          fill={colour3}
          d="M446.8,543.9c0,0,2.2,5.3,0,12.1c0,0,3.4-9.9,6.6-11L446.8,543.9z"
        />
        <path
          fill={colour7}
          d="M332,545c-2.1,2-4.5,3.7-5.7,3.6c-1.2-0.1-3.7-2.4-2.8-3C324.4,544.9,332,545,332,545z"
        />
        <path
          fill={colour6}
          d="M352.5,574.6c4.3-4.2,16.8-12.5,20.9-12.3c4.1,0.1,14.8,4.5,14.8,4.5l4.8,9.3c0,0-10.9-6.6-19-7.9
		C366,567.1,352.5,574.6,352.5,574.6z"
        />
        <path
          fill={colour2}
          d="M320.7,545.3c2-0.5,2.8-1.2,6.5-0.9c3.7,0.3,6.3-0.3,6.3-0.3s-2.9,0.8-5.6,1
		C325.2,545.3,320.7,545.3,320.7,545.3z"
        />
        <g>
          <path
            fill={colour3}
            d="M455.7,593.6c0.2,0.2,0.4,0.4,0.6,0.6L455.7,593.6z"
          />
          <path
            fill={colour3}
            d="M453.1,582.9l-4.8,3.9l7.5,6.7C453.7,591.3,452.2,585.3,453.1,582.9z"
          />
        </g>
        <polygon fill={colour3} points="425.2,565.2 427.4,562.1 428.1,567.9 	" />
        <path
          fill={colour2}
          d="M422.9,550.8c-1.4,0.6-2.4,0.6-2.4,0.6l5,1.8C424.7,551.9,422.9,550.8,422.9,550.8z"
        />
        <path
          fill={colour2}
          d="M335.7,543.9l-4.5,0.5c0,0,2.7,1.7,2,4.6c-0.7,3,0.3,0.2,0.3,0.2l1.2-0.4C334.8,548.8,334.1,544.3,335.7,543.9
		z"
        />
        <path
          fill={colour2}
          d="M325,544.9l2.9-0.2c0,0-1.5-2-0.6-5c0.8-3-0.1-0.2-0.1-0.2l-0.8,0.4C326.3,540,326,544.5,325,544.9z"
        />
      </g>
    </>
  );
};

export default Mouth_6;
